export const SESSION_EXPIRED_NOTICE_FLAG = 'show_session_expired_notice';

/**
 * Set flag so notice modal opens after a full page reload (e.g. performSimpleLogout).
 */
export const setSessionExpiredNoticePending = () => {
  sessionStorage.setItem(SESSION_EXPIRED_NOTICE_FLAG, 'true');
};

/** @returns {boolean} */
export const hasSessionExpiredNoticePending = () =>
  sessionStorage.getItem(SESSION_EXPIRED_NOTICE_FLAG) === 'true';

export const clearSessionExpiredNoticePending = () => {
  sessionStorage.removeItem(SESSION_EXPIRED_NOTICE_FLAG);
};

/**
 * Read and clear the post-reload notice flag.
 * @returns {boolean}
 */
export const consumeSessionExpiredNoticePending = () => {
  if (!hasSessionExpiredNoticePending()) {
    return false;
  }
  clearSessionExpiredNoticePending();
  return true;
};
